import styled from 'styled-components';

import { body } from '@constants/fonts';

export const Tooltip = styled.div<{ top: number; left: number }>`
  width: 100%;
  position: absolute;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  border-radius: 7px;
  background-color: white;
  box-shadow: ${({ theme }) => theme.shadows[24]};
  font-family: ${body};
  font-weight: lighter;
  text-align: left;

  border: none;
  border-right: 3px solid ${(props) => props.color};

  padding: 15px 20px 15px 12px;
  margin: 0 0 15px 0;

  transition: box-shadow 0.1s;
`;

export const CommandButtonWrapper = styled.div`
  margin: 2px;
`;

export const TooltipTitle = styled.h2`
  color: ${({ theme }) => theme.palette.primary.main};
  padding: 0 0 10px 20px;
  margin: 0;
`;

export const ContentWrapper = styled.div`
  padding-left: 10px;
`;
